import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { ServiceComponent } from './components/service/service.component';
import { KendoModule } from '@shared/kendo.module';
import { QualificationComponent } from './components/qualification/qualification.component';
import { ShiftTypeComponent } from './components/shift-type/shift-type.component';
import { OrderByComponent } from './components/order-by/order-by.component';
import { ExpertiseComponent } from './components/expertise/expertise.component';
import { SubExpertiseComponent } from './components/sub-expertise/sub-expertise.component';
import { ShiftDocumentComponent } from './components/shift-document/shift-document.component';
import { ShiftInfectionComponent } from './components/shift-infection/shift-infection.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { DocViewerComponent } from './components/doc-viewer/doc-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { PreferredPersonnelComponent } from './components/preferred-personnel/preferred-personnel.component';
import { CancelBookingComponent } from './components/cancel-booking/cancel-booking.component';
import { ReasonComponent } from './components/reason/reason.component';
import { DaterangePickerComponent } from './components/daterange-picker/daterange-picker.component';
import { StaffRequestTypeComponent } from './components/staff-request-type/staff-request-type.component';
import { StaffRequestReasonComponent } from './components/staff-request-reason/staff-request-reason.component';
import { PersonnelNameComponent } from './components/personnel-name/personnel-name.component';
import { MemberCardComponent } from '@modules/booking/components/member-card/member-card.component';
import { NoWhiteSpaceDirective } from './directives/no-white-space-input.directive';
import { FieldLengthDirective } from './directives/field-length.directive';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { SelectionPopupComponent } from './components/selection-popup/selection-popup.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


@NgModule({
  declarations: [
    DeliveryComponent,
    ServiceComponent,
    QualificationComponent,
    ShiftTypeComponent,
    OrderByComponent,
    ExpertiseComponent,
    SubExpertiseComponent,
    ShiftDocumentComponent,
    ShiftInfectionComponent,
    DatepickerComponent,
    DocViewerComponent,
    ImageViewerComponent,
    PreferredPersonnelComponent,
    CancelBookingComponent,
    ReasonComponent,
    DaterangePickerComponent,
    StaffRequestTypeComponent,
    StaffRequestReasonComponent,
    PersonnelNameComponent,    
    MemberCardComponent,
    NoWhiteSpaceDirective,
    FieldLengthDirective,
    CustomDropdownComponent,
    SelectionPopupComponent
  ],
  imports: [
    CommonModule,
    KendoModule,
    MatDatepickerModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    NgxDocViewerModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports:[
    DeliveryComponent,
    ServiceComponent,
    QualificationComponent,
    ShiftTypeComponent,
    OrderByComponent,
    ExpertiseComponent,
    SubExpertiseComponent,
    ShiftDocumentComponent,
    ShiftInfectionComponent,
    DatepickerComponent,
    DocViewerComponent,
    ImageViewerComponent,
    PreferredPersonnelComponent,
    CancelBookingComponent,
    DaterangePickerComponent,
    ReasonComponent,
    StaffRequestTypeComponent,
    StaffRequestReasonComponent,
    PersonnelNameComponent,
    MemberCardComponent,
    NoWhiteSpaceDirective,
    CustomDropdownComponent,
    SelectionPopupComponent,
    FieldLengthDirective
	]
})
export class SharedModule { }
